import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { definedSearchParams } from '@/lib/search-params';

import { PlanOpsScreen } from './PlanOpsScreen';
import type { PlanOpsSearch } from './plan-ops-search';

const route = getRouteApi('/plan-operations');

export function PlanOpsRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const onSearchChange = useCallback(
    (next: PlanOpsSearch) => {
      void navigate({
        replace: true,
        // Absent rather than undefined: an `?status=` with no value in the URL
        // is noise a shared link should not carry.
        search: () => definedSearchParams(next),
      });
    },
    [navigate],
  );

  return <PlanOpsScreen search={search} onSearchChange={onSearchChange} />;
}
